import createSagaMiddleware from 'redux-saga';
import { createStore, compose, applyMiddleware } from 'redux';
import { rootReducer, sagas } from './ducks';

const middlewares = [];
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const { logger } = require('redux-logger');
  middlewares.push(logger); // for viewing redux logs during development
}
// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);

const store = compose(applyMiddleware(...middlewares))(createStore)(rootReducer);

sagaMiddleware.run(sagas);

export default store;
